//Node Modules
import axios from 'axios'

//Types
import { DownloadTOCInfo, DownloadDto } from 'types/download'

const BASE_URL = '/packages'

export function downloadToc(lang:string, softwareId: string, softwareVersion: string, softwareSpecialConfig?:string): Promise<DownloadTOCInfo> {
  return axios.get<DownloadTOCInfo>(`${BASE_URL}/pdftoc?softwareId=${softwareId}&softwareVersion=${softwareVersion}${softwareSpecialConfig ? '&softwareSpecialConfig='+softwareSpecialConfig : ''}`, { headers: {'Accept-Language': lang}})
    .then(result => result.data)
}

export function downloadFiles(downloadDto: DownloadDto, lang:string, softwareId: string, softwareVersion: string, softwareSpecialConfig?:string): Promise<DownloadTOCInfo> {
  return axios.post(`${BASE_URL}/download?softwareId=${softwareId}&softwareVersion=${softwareVersion}${softwareSpecialConfig ? '&softwareSpecialConfig='+softwareSpecialConfig : ''}`, downloadDto,{ headers: {'Accept-Language': lang}})
    .then(result => result.data)
}

export function downloadComplete(downloadDto: DownloadDto, lang:string, softwareId: string, softwareVersion: string, softwareSpecialConfig?:string): Promise<DownloadTOCInfo> {
  return axios.post(`${BASE_URL}/download/complete?softwareId=${softwareId}&softwareVersion=${softwareVersion}${softwareSpecialConfig ? '&softwareSpecialConfig='+softwareSpecialConfig : ''}`, downloadDto,{ headers: {'Accept-Language': lang}})
    .then(result => result.data)
}